import NAME from "./constants";

export const getRequestsRows = store => store[NAME].requestsRows || {};
export const getHelp = store => store[NAME].helpDocumentation;
export const gettingRequestsRows = store => store[NAME].gettingRequestsRows;
export const getLocale = store => store[NAME].locale;
export const getDateFormat = store => store[NAME].dateFormat;

export const loading = store => store[NAME].gettingRequestsRows || store[NAME].sendingMail;
